module.exports = __webpack_public_path__ + "img/volume_mute_black_24dp.ba039326.svg";